import * as ko from "knockout";
import Bao from "./../../services/bao-service";
function TicketModuleViewModel(parent) {
    var self = this;
    self.Bao = Bao;
    self.parent = parent;
    self.Initialized = ko.observable(false);
    self.DashboardUrl = ko.observable();
    self.FilterTypes = ko.observableArray([]);
    self.Filter = ko.observable();
    self.TicketCollection = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.SelectedRow = ko.observable({});
    self.SelectRow = function (item) {
        self.SelectedRow(item);
        return true;
    };
    self.Filter.subscribe(function (filter) {
        if (self.Initialized()) {
            self.SaveSelectedFilter(filter);
        }
    });
    self.SaveSelectedFilter = function (key) {
        return Bao.post("SynosetStartModule/SaveSelectedTicketFilter", JSON.stringify({
            key: key
        }));
    };
    self.TextFilter = ko.observable();
    self.TextFilter.subscribe(function (filter) {
        if (self.Initialized()) {
            self.TextFilter(filter);
            self.Load();
        }
    });
    self.SaveSelectedFilter = function (key) {
        return Bao.post("SynosetStartModule/SaveSelectedTicketFilter", JSON.stringify({
            key: key
        }));
    };
    self.SaveSelectedSort = function (sort) {
        return Bao.post("SynosetStartModule/SaveSelectedSorting", JSON.stringify({
            column: sort[0].Column,
            direction: sort[0].Direction
        }));
    };
    self.DisplayTotalRows = ko.computed(function () {
        if (self.TotalRows() <= self.PageSize()) {
            return self.TotalRows();
        }
        else {
            return self.PageSize() + " / " + self.TotalRows();
        }
    });
    self.PageIndex.subscribe(function () {
        self.Load();
    });
    self.Sorting.subscribe(function () {
        self.SaveSelectedSort(self.Sorting());
        self.Load();
    });
    self.Filter.subscribe(function (item) {
        self.DashboardUrl("");
        $.each(self.FilterTypes(), function (index, row) {
            if (row.Key == item) {
                self.DashboardUrl(row.OpenUrl);
            }
        });
        self.Load();
    });
    self.Load = function () {
        var def = $.Deferred();
        if (self.Initialized()) {
            Bao.post("SynosetStartModule/GetTickets", JSON.stringify({
                filter: self.Filter(),
                textFilter: self.TextFilter(),
                pageIndex: self.PageIndex(),
                pageSize: self.PageSize(),
                sorting: self.Sorting()
            }), function (searchResult) {
                self.SelectedRow(null);
                self.TotalRows(0);
                self.TicketCollection([]);
                if (searchResult != null && searchResult.Models != null) {
                    self.TicketCollection(searchResult.Models);
                    self.TotalRows(searchResult.TotalRows);
                }
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.init = function () {
        return Bao.post("SynosetStartModule/GetTicketFilter", JSON.stringify({}), function (searchResult) {
            self.FilterTypes([]);
            if (searchResult != null) {
                self.FilterTypes(searchResult.Filter);
                self.Filter(searchResult.SelectedValue);
                if (searchResult.SelectedSorting != null) {
                    var sortObj = new Object();
                    sortObj = {
                        "Column": searchResult.SelectedSorting[0],
                        "Direction": searchResult.SelectedSorting[1]
                    };
                    self.Sorting([sortObj]);
                }
            }
            self.Initialized(true);
        });
    };
    self.loaded = function () {
        return self.Load();
    };
    self.parent.Refresh = function () {
        self.Load();
    };
}
export default TicketModuleViewModel;